import {BenjiKIVScatterSymbol} from "../reels/BenjiKIVScatterSymbol";
import {SymbolPositionData} from "../../core/reel/ReelInterfaces";

/**
 * Created by Jerker Nord on 2023-01-19.
 */

export class BenjiKIVPoolScatterSymbols {

    private _scatterSymbols:BenjiKIVScatterSymbol[];

    public init():void {
        this._scatterSymbols = [];
        for(let i:number = 0; i < 5; i++) {
            this._scatterSymbols.push(this.createScatter());
        }
    }

    private createScatter():BenjiKIVScatterSymbol {
        return new BenjiKIVScatterSymbol();
    }

    public getSymbol(symbolName:string, symbolPositionData:SymbolPositionData):BenjiKIVScatterSymbol {
        for(let i:number = 0; i < this._scatterSymbols.length; i++) {
            if(this._scatterSymbols[i].isUsed == false) {
                this._scatterSymbols[i].isUsed = true;
                this._scatterSymbols[i].symbolName = symbolName;
                this._scatterSymbols[i].stackedSymbolName = symbolName;
                this._scatterSymbols[i].reelPosition = symbolPositionData.position;
                this._scatterSymbols[i].reelId = symbolPositionData.reelID;
                return this._scatterSymbols[i];
            }
        }
        //console.log("Creating more Scatter Syms!");
        this._scatterSymbols.push(this.createScatter());
        return this.getSymbol(symbolName, symbolPositionData);
    }

    public spinAllActiveScatters():void {
        for(let i:number = 0; i < this._scatterSymbols.length; i++) {
            if(this._scatterSymbols[i].isUsed == true) {
                this._scatterSymbols[i].playDiceSpinAnimation();
            }
        }
    }

    public getScatterSymbolOnReel(reelId:number):BenjiKIVScatterSymbol {
        for(let i:number = 0; i < this._scatterSymbols.length; i++) {
            if(this._scatterSymbols[i].isUsed == true && this._scatterSymbols[i].reelId == reelId) {
                return this._scatterSymbols[i];
            }
        }
        throw new Error("BenjiKIVPoolScatterSymbols: No Scatter on that reel!");
    }
}